class BrowserController
{

    /**
     * @param {Logger} logger
     * @param {EventDispatcher} eventDispatcher
     * @param {Window} wnd
     * @param {Document} doc
     */
    constructor(logger, eventDispatcher, wnd, doc) {

        // 1. Setting environment
        this._logger = logger;
        this._ed = eventDispatcher;
        this._window = wnd;
        if (typeof doc === 'undefined') {
            doc = wnd.document;
        }
        this._document = doc;

        // 2. Ready state params
        this._docReadyState = 0;
        this._onNewDocReadyState = this._onNewDocReadyState.bind(this);

        // 3. Size and scroll
        this._documentSize = this.getDocumentSize();
        this._windowSize = this.getWindowSize();
        this._scroll = this.getScroll();
        this._onResize = this._onResize.bind(this);
        this._onScroll = this._onScroll.bind(this);

        // 4. Binding
        this._bind();

    }

    getDocument()
    {
        return this._document;
    }

    getWindow()
    {
        return this._window;
    }

    documentQuerySelector(query)
    {
        return this._document.querySelector(query);
    }

    start()
    {
        this._updateSizesAndScroll();
        this._ed.on('doc.ready', this._onResize);
        this._ed.on('doc.complete', this._onResize);
        this._onNewDocReadyState();
        this._onResize();
        this._logger.debug('started');
    }

    _bind()
    {
        this._document.onreadystatechange = this._onNewDocReadyState;
        this._document.onresize = this._onResize;
        this._window.onresize = this._onResize;
        this._document.onscroll = this._onScroll;
        this._window.onscroll = this._onScroll;
    }

    _onNewDocReadyState()
    {
        this._setNewDocReadyState(
            this._document.readyState
        );
    }

    _setNewDocReadyState(readyState)
    {
        let rs = 0;
        if (readyState === 'interactive') {
            rs = 1;
        } else if (readyState === 'complete') {
            rs = 2;
        }
        while (rs > this._docReadyState) {
            this._docReadyState++;
            this._triggerNewDocReadyState();
        }
    }

    _triggerNewDocReadyState()
    {
        if (this._docReadyState === 1) {
            this._ed.dispatch('doc.ready');
        } else if (this._docReadyState === 2) {
            this._ed.dispatch('doc.complete');
        }
    }

    getWindowSize()
    {

        let wi = 0;
        let he = 0;
        if (typeof this._window.innerWidth == 'number') {
            //Non-IE
            wi = this._window.innerWidth;
            he = this._window.innerHeight;
        } else if (this._document.documentElement && (this._document.documentElement.clientWidth || this._document.documentElement.clientHeight)) {
            //IE 6+ in 'standards compliant mode'
            wi = this._document.documentElement.clientWidth;
            he = this._document.documentElement.clientHeight;
        } else if (this._document.body && (this._document.body.clientWidth || this._document.body.clientHeight)) {
            //IE 4 compatible
            wi = this._document.body.clientWidth;
            he = this._document.body.clientHeight;
        }
        return {
            width: wi,
            height: he
        };
    }

    getDocumentSize()
    {
        let wi1, wi2 = 0;
        let he1, he2 = 0;
        if (this._document.body && (this._document.body.clientWidth || this._document.body.clientHeight)) {
            wi1 = this._document.body.clientWidth;
            he1 = this._document.body.clientHeight;
        }
        if (this._document.documentElement && (this._document.documentElement.clientWidth || this._document.documentElement.clientHeight)) {
            wi2 = this._document.documentElement.clientWidth;
            he2 = this._document.documentElement.clientHeight;
        }
        return {
            width: wi1 > wi2 ? wi1 : wi2,
            height: he1 > he2 ? he1 : he2
        };
    }

    getScroll()
    {
        let x = 0, y = 0;
        if(typeof this._window.pageYOffset  == 'number') {
            //Netscape compliant
            y = this._window.pageYOffset;
            x = this._window.pageXOffset;
        } else if (this._document.body && (this._document.body.scrollLeft || this._document.body.scrollTop)) {
            //DOM compliant
            y = this._document.body.scrollTop;
            x = this._document.body.scrollLeft;
        } else if (this._document.documentElement && (this._document.documentElement.scrollLeft || this._document.documentElement.scrollTop)) {
            //IE6 standards compliant mode
            y = this._document.documentElement.scrollTop;
            x = this._document.documentElement.scrollLeft;
        }
        return {
            x: x,
            y: y
        };
    }

    _updateSizesAndScroll()
    {
        this._windowSize = this.getWindowSize();
        this._documentSize = this.getDocumentSize();
        this._scroll = this.getScroll();
    }

    _onResize()
    {

        // 1. Saving old values
        let oldWindowSize = this._windowSize;
        let oldDocumentSize = this._documentSize;
        let oldScroll = this._scroll;

        // 2. Getting new values
        this._updateSizesAndScroll();

        // 3. Checking for real changes
        let isWindowResized = (oldWindowSize.width !== this._windowSize.width) || (oldWindowSize.height !== this._windowSize.height);
        // let isDocumentResized = (oldDocumentSize.width !== this._documentSize.width) || (oldDocumentSize.height !== this._documentSize.height);
        // let isResized = isWindowResized || isDocumentResized;
        let isScrolled = (oldScroll.x !== this._scroll.x) || (oldScroll.y !== this._scroll.y);

        // 4. Dispatch if window resized
        if (isWindowResized) {
            this._logger.debug('Window resized to ' + this._windowSize.width + 'x' + this._windowSize.height);
            this._ed.dispatch(
                'wnd.resized',
                {
                    old: {
                        window: oldWindowSize,
                        document: oldDocumentSize,
                        scroll: oldScroll
                    },
                    new: {
                        window: this._windowSize,
                        document: this._documentSize,
                        scroll: this._scroll
                    }
                }
            );
        }

        // 5. Dispatch if scrolled
        if (isScrolled) {
            this._logger.debug('Window scrolled to ' + this._scroll.x + 'x' + this._scroll.y);
            this._ed.dispatch(
                'wnd.scrolled',
                {
                    old: oldScroll,
                    new: this._scroll
                }
            );
        }

    }

    _onScroll()
    {

        // 1. Saving old values
        let oldScroll = this._scroll;

        // 2. Getting new values
        this._updateSizesAndScroll();

        // 3. Checking for real changes
        let isScrolled = (oldScroll.x !== this._scroll.x) || (oldScroll.y !== this._scroll.y);

        // 4. Dispatch if scrolled
        if (isScrolled) {
            this._logger.debug('Window scrolled to ' + this._scroll.x + 'x' + this._scroll.y);
            this._ed.dispatch(
                'wnd.scrolled',
                {
                    old: oldScroll,
                    new: this._scroll
                }
            );
        }

    }

}

export default BrowserController;